import Hammer from "hammerjs";

import { DomUtil } from "@/shared/ui/Helper";

export class Slider {
    private $element: JQuery;
    private $line: JQuery;
    private $percent: JQuery;
    private $handle: JQuery;

    public onChange?: { (val: number) };
    private touchCtrl: HammerManager;
    private currentPosition?: number;
    private maxOffset: number;
    private maxPercent = 1;
    private startValue?: number;

    constructor(maxPercent?: number) {
        if (maxPercent !== undefined) this.maxPercent = maxPercent;

        this.$element = $('<div class="slider inactive" />');
        this.$line = $('<div class="line" />').appendTo(this.$element);
        this.$handle = $('<div class="handle"><div class="inner" /></div>').appendTo(this.$line);
        this.$percent = $('<div class="perc"></div>').appendTo(this.$element);

        this.maxOffset = this.$line.width();
        this.touchCtrl = new Hammer(this.$handle[0], {
            recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 }]],
        });

        this.touchCtrl.on("panstart", () => {
            this.maxOffset = this.$line.width();
            this.currentPosition = DomUtil.translatePosition(this.$handle).x;
            this.$handle.addClass("grabbing");
            this.updatePercent();
            this.startValue = this.getValue();
        });

        this.touchCtrl.on("panmove", (ev) => {
            const newPosition = this.minMaxNewPos(this.currentPosition! + ev.deltaX);
            this.$handle.css({ transform: "translate3d(" + newPosition + "px, 0, 0)" });

            const newPercent = this.updatePercent(newPosition);
            const changed = this.startValue !== newPercent;
            this.startValue = newPercent;

            if (changed && this.onChange !== undefined) this.onChange(newPercent);
        });

        this.touchCtrl.on("panend", () => {
            this.currentPosition = DomUtil.translatePosition(this.$handle).x;
            this.$handle.removeClass("grabbing");
            this.updatePercent();
        });

        this.updatePercent();
    }

    public getValue(): number | undefined {
        return this.startValue;
    }

    public setValue(percent: number): Slider {
        if (percent > this.maxPercent) percent = this.maxPercent;
        else if (percent < 0) percent = 0;
        else percent = Math.round(percent * 100) / 100;

        if (this.maxOffset === 0) {
            this.startValue = percent;
            return this;
        }

        this.currentPosition = this.percentToPosition(percent);
        this.$handle.css({ transform: "translate3d(" + this.currentPosition + "px, 0, 0)" });
        this.startValue = this.updatePercent();

        return this;
    }

    private positionToPercent(pos: number): number {
        return (this.maxPercent / this.maxOffset) * pos;
    }

    private percentToPosition(percent: number): number {
        return Math.round((this.maxOffset / this.maxPercent) * percent);
    }

    private updatePercent(withPosition?: number): number {
        const rounded = Math.round(
            this.positionToPercent(withPosition === undefined ? this.currentPosition! : withPosition) * 100
        );
        this.$percent.html(rounded + " %");

        return rounded / 100;
    }

    private minMaxNewPos(pos: number): number {
        if (pos < 0) pos = 0;
        else if (pos > this.maxOffset) pos = this.maxOffset;

        return pos;
    }

    public resize() {
        this.maxOffset = this.$line.width();
        this.updatePercent();
        this.setValue(this.startValue!);
    }

    public appendTo($element: JQuery): Slider {
        this.$element.appendTo($element);
        this.maxOffset = this.$line.width();

        return this;
    }
}
